/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ConstructionSite } from '../../models/construction-site';

export interface ApiV0ConstructionsiteGetConstructionSitesByCompanyGet$Plain$Params {
  companyId?: string;
}

export function apiV0ConstructionsiteGetConstructionSitesByCompanyGet$Plain(http: HttpClient, rootUrl: string, params?: ApiV0ConstructionsiteGetConstructionSitesByCompanyGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ConstructionSite>>> {
  const rb = new RequestBuilder(rootUrl, apiV0ConstructionsiteGetConstructionSitesByCompanyGet$Plain.PATH, 'get');
  if (params) {
    rb.query('companyId', params.companyId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ConstructionSite>>;
    })
  );
}

apiV0ConstructionsiteGetConstructionSitesByCompanyGet$Plain.PATH = '/api/v0/constructionsite/getConstructionSitesByCompany';
